export const getFieldTranslations = (t: any) => ({
  name: t("a6_static_data.columns.name", { ns: "tables", defaultValue: "Nom" }),
  currency: t("a6_static_data.columns.currency", {
    ns: "tables",
    defaultValue: "Devise",
  }),
  isin: t("a6_static_data.columns.isin", {
    ns: "tables",
    defaultValue: "ISIN",
  }),
  code: t("a6_static_data.columns.code", {
    ns: "tables",
    defaultValue: "Code",
  }),
  company_name: t("a6_static_data.columns.company_name", {
    ns: "tables",
    defaultValue: "Société de gestion",
  }),
  asset_class_1: t("a6_static_data.columns.asset_class_1", {
    ns: "tables",
    defaultValue: "Classe d'actif principale",
  }),
  asset_class_2: t("a6_static_data.columns.asset_class_2", {
    ns: "tables",
    defaultValue: "Classe d'actifs",
  }),
  a6_issuer_name: t("a6_static_data.columns.a6_issuer_name", {
    ns: "tables",
    defaultValue: "Émetteur",
  }),
  strategy_id: t("a6_static_data.columns.strategy_id", {
    ns: "tables",
    defaultValue: "ID de la stratégie",
  }),
  loan_rate: t("a6_static_data.columns.loan_rate", {
    ns: "tables",
    defaultValue: "Taux du prêt",
  }),
  loan_amount_granted: t("a6_static_data.columns.loan_amount_granted", {
    ns: "tables",
    defaultValue: "Montant du prêt accordé",
  }),
  loan_with_collateral: t("a6_static_data.columns.loan_with_collateral", {
    ns: "tables",
    defaultValue: "Prêt consenti avec nantissement",
  }),
  concentrated_asset: t("a6_static_data.columns.concentrated_asset", {
    ns: "tables",
    defaultValue: "Actif concentré du client",
  }),
  maturity_date: t("a6_static_data.columns.maturity_date", {
    ns: "tables",
    defaultValue: "Date de maturité",
  }),
  coupon_rate: t("a6_static_data.columns.coupon_rate", {
    ns: "tables",
    defaultValue: "Taux du coupon",
  }),
  commitment: t("a6_static_data.columns.commitment", {
    ns: "tables",
    defaultValue: "Engagement initial",
  }),
  capital_callable: t("a6_static_data.columns.capital_callable", {
    ns: "tables",
    defaultValue: "Capital exigible",
  }),
  owner: t("a6_static_data.columns.owner", {
    ns: "tables",
    defaultValue: "Propriétaire",
  }),
  property_id: t("a6_static_data.columns.property_id", {
    ns: "tables",
    defaultValue: "ID de la propriété",
  }),
  property_type: t("a6_static_data.columns.property_type", {
    ns: "tables",
    defaultValue: "Type de bien",
  }),
  property_size: t("a6_static_data.columns.property_size", {
    ns: "tables",
    defaultValue: "Taille du bien",
  }),
  financing_own_funds: t("a6_static_data.columns.financing_own_funds", {
    ns: "tables",
    defaultValue: "Financement fonds propres",
  }),
  financing_mortage: t("a6_static_data.columns.financing_mortage", {
    ns: "tables",
    defaultValue: "Financement hypothécaire",
  }),
  stock_option_strike: t("a6_static_data.columns.stock_option_strike", {
    ns: "tables",
    defaultValue: "Prix d'exercice",
  }),
  created_at: t("technical_info.created_at", { defaultValue: "Créé le" }),
  updated_at: t("technical_info.updated_at", { defaultValue: "Mis à jour le" }),
});

export default getFieldTranslations;
